import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { CurrentService } from '../../../../services/current.service';
import { DatasService } from '../../../../services/datas.service';
import { GTM } from 'src/app/services/gtm.service';
import { Router } from '@angular/router';
import { getHbmTotalSteps } from 'src/app/services/helpers/app-context-helper';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'ng-casto-storage-front',
  templateUrl: './front.component.html',
})
export class StorageFrontComponent implements OnInit {
  fronts: any[];

  @Output() onComplete: EventEmitter<void> = new EventEmitter();

  constructor(
    public current: CurrentService,
    public datas: DatasService,
    private readonly gtm: GTM,
    private readonly router: Router,
    private readonly customer: CustomerService
  ) { }

  ngOnInit(): void {
    this.gtm.trackPage(`${this.router.url}/choix/portes`, 'Rangements | Choix', {
      stepNumber: 3,
      totalSteps: getHbmTotalSteps(this.customer.context),
    });

    this.fronts = this.datas.storageInspiration.getFronts(
      this.current.storage.inspirationId,
      this.current.storage.boxId
    );

    if (this.fronts.length === 1) {
      this.selectFront(this.fronts[0].id);
    }
  }

  selectFront(frontId: number) {
    if (this.current.storage.frontId !== frontId) {
      this.current.storage.frontId = frontId;
    }

    this.onComplete.emit();
  }
}
